// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yqMp","title":"styles_title__1_aIX"};